import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "driverManage";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    driverList: {
      list: [],
      total: 0,
    }, //列表数据
  },
  actions: {
    //获取司机列表数据
    async getDriverData({ commit }, payload) {
      let result = await api.get(
        `/api/Driver?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setDriverList", result.data);
      }
      return result;
    },
    //添加数据
    async addDriver(a, payload) {
      let result = await api.post("/api/Driver", payload);
      return result.data;
    },
    //获取单条数据
    async getSingleDriver(a, payload) {
      let result = await api.get(`/api/Driver/` + payload);
      return result.data;
    },
    //修改数据
    async updateDriver(a, payload) {
      let result = await api.put(`/api/Driver`, payload);
      return result.data;
    },
    //删除数据
    async delDriver(a, payload) {
      let result = await api.delete(`/api/Driver/` + payload);
      return result;
    },
    // 获取司机商下拉框列表
    async getDriverKeyValue(a, payload) {
      let result = await api.get(`/api/Driver/KeyValue`);
      return result.data;
    },
  },
  mutations: {
    setDriverList(state, payload) {
      state.driverList = payload;
    },
  },
});

export default moduleName;
